import { render, staticRenderFns } from "./TextSettingChecker.vue?vue&type=template&id=69c7e93d"
import script from "./TextSettingChecker.vue?vue&type=script&lang=ts"
export * from "./TextSettingChecker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports